import Combustor from '@/models/Combustor'
import User, { hasRole, Role } from '@/models/User'

export default class CombustorPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, combustor: Combustor) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === combustor.entry.catalog.company.id
			case Role.AUDITOR:
				return combustor.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, combustor: Combustor) {
		return hasRole(user, Role.USER) && user.company?.id === combustor.entry.catalog.company.id
	}

	restore(user: User, combustor: Combustor) {
		return hasRole(user, Role.USER) && user.company?.id === combustor.entry.catalog.company.id
	}

	delete(user: User, combustor: Combustor) {
		return hasRole(user, Role.USER) && user.company?.id === combustor.entry.catalog.company.id
	}

	forceDelete(_user: User, _combustor: Combustor) {
		return false
	}
}
